import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Bloc } from 'src/app/models/bloc.model';
import { Conjunt } from 'src/app/models/conjunt.model';
import { Observacio } from 'src/app/models/observacio.model';
import { ConfirmService } from 'src/app/services/confirm.service';
import { ModalService } from 'src/app/services/modal.service';
import { RumiService } from 'src/app/services/rumi.service';

@Component({
  selector: 'app-questionari-observacions',
  templateUrl: './questionari-observacions.component.html'
})
export class QuestionariObservacionsComponent implements OnInit {

  public questionariObservacionsForm: FormGroup;

  public blocSeleccionat: Bloc;
  public conjuntSeleccionat: Conjunt;

  public get simulacio(){
    return this.rumiService.simulacio;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private rumiService: RumiService,
    private _fb: FormBuilder,
    public modal: ModalService,
    public confirm: ConfirmService
  ) { }

  ngOnInit() {
    this.rumiService.pestanyaActiva = this.router.url;
    this.initQuestionariObservacionsForm();
  }

  goToNextStep() {
    this.rumiService.conjuntsSeleccionats = [];
    this.simulacio.blocs.forEach(bloc => {
      bloc.conjunts.forEach(conjunt => {
        if((conjunt.observacions != null && conjunt.observacions.length>0) || (conjunt.observacionsProposades != null && conjunt.observacionsProposades.length>0)){
          if(conjunt.observacions != null && conjunt.observacions.length>0 && conjunt.idGravetat == null){
            conjunt.idGravetat = 0;
          }
          this.rumiService.conjuntsSeleccionats.push(conjunt);
        }
      });
    });
    if(this.validar()){
      this.router.navigate(['simulacio','apreciacio-gravetat']);
    }else{
      this.modal.open('errors');
    }
  }

  goToPrevStep() {
    this.confirm.close();
    this.router.navigate(['simulacio','inici-simulacio']);
  }

  navigate(url: String) {
    this.router.navigate([url]);
  }

  private initQuestionariObservacionsForm() {
    this.questionariObservacionsForm = this._fb.group({
      observacions_disponibles: [[], []],
      observacions_seleccionades: [[], []],
      observacions_proposades: [[], []],
      nova_observacio_proposada: ['', []],
      filtre: ['', []]
    });

    this.questionariObservacionsForm.get('filtre').valueChanges.subscribe(value=>{
      if(value != ''){
        this.rumiService.simulacio.blocs.forEach(bloc => {
          if(this.teConjuntsAmbFiltre(bloc)){
            bloc.opened = true;
          }
        });
      }
    })
  }

  seleccionar() {
    var observacions_disponibles = this.questionariObservacionsForm.get('observacions_disponibles').value;
    observacions_disponibles.forEach((element) => {
      this.conjuntSeleccionat.observacionsDisponibles.forEach((observacioDisponible, index) => {
        if (observacioDisponible.id == element) {
          this.conjuntSeleccionat.observacions.push(observacioDisponible);
          this.conjuntSeleccionat.observacionsDisponibles.splice(index, 1);
        }
      });
    });
    this.conjuntSeleccionat.observacionsDisponibles.sort(this.compareObservacions);
    this.conjuntSeleccionat.observacions.sort(this.compareObservacions);
  }
  deseleccionar() {
    var observacions_seleccionades = this.questionariObservacionsForm.get('observacions_seleccionades').value;
    observacions_seleccionades.forEach((element) => {
      this.conjuntSeleccionat.observacions.forEach((observacio, index) => {
        if (observacio.id == element) {
          this.conjuntSeleccionat.observacionsDisponibles.push(observacio);
          this.conjuntSeleccionat.observacions.splice(index, 1);
        }
      });
    });
    this.conjuntSeleccionat.observacionsDisponibles.sort(this.compareObservacions);
    this.conjuntSeleccionat.observacions.sort(this.compareObservacions);
  }

  marca(bloc: Bloc, conjunt: Conjunt) {
    if (conjunt.observacions == null) {
      conjunt.observacions = [];
    }
    if(conjunt.observacionsProposades == null){
      conjunt.observacionsProposades = [];
      conjunt.numAltresObservacions = 0;
    }
    this.blocSeleccionat = bloc;
    this.conjuntSeleccionat = conjunt;
    this.questionariObservacionsForm.get('nova_observacio_proposada').setValue('');
  }  

  compareObservacions(observacio1: Observacio, observacio2: Observacio) {
    if (parseInt(observacio1.descripcio.split(".")[1]) > parseInt(observacio2.descripcio.split(".")[1])) {
      return 1;
    }
    if (parseInt(observacio1.descripcio.split(".")[1]) < parseInt(observacio2.descripcio.split(".")[1])) {
      return -1;
    }
    return 0;
  }

  afegir_observacio_proposada(){
    let novaObservacioProposada: Observacio = new Observacio();
    novaObservacioProposada.descripcio = this.questionariObservacionsForm.get('nova_observacio_proposada').value;
    novaObservacioProposada.id = this.conjuntSeleccionat.numAltresObservacions++;
    novaObservacioProposada.idConjunt = this.conjuntSeleccionat.id;
    this.conjuntSeleccionat.observacionsProposades.push(novaObservacioProposada);
    this.questionariObservacionsForm.get('nova_observacio_proposada').setValue('');
  }

  eliminar_observacions_proposades_seleccionades(){
    let observacions_proposades = this.questionariObservacionsForm.get('observacions_proposades').value;
    observacions_proposades.forEach((element) => {
      this.conjuntSeleccionat.observacionsProposades.forEach((observacio, index) => {
        if (observacio.id == element) {
          this.conjuntSeleccionat.observacionsProposades.splice(index, 1);
        }
      });
    });
  }

  teConjuntsAmbFiltre(bloc){
    var resultat = false;
    bloc.conjunts.forEach(conjunt => {
      if(conjunt.descripcio.includes(this.questionariObservacionsForm.get('filtre').value)){
        resultat = true;
      }
    });
    return resultat;
  }

  senyalarTextFiltre(text: string){
    var filtre = this.questionariObservacionsForm.get('filtre').value;
    var nouText = text;
    if(filtre != ''){
      nouText = text.split(filtre).join('<mark>'+filtre+'</mark>');
    }
    return nouText;
  }

  colapsar() {
    this.simulacio.blocs.forEach(bloc => bloc.opened = false);
  }

  expandir() {
    this.simulacio.blocs.forEach(bloc => bloc.opened = true);
  }

  validar(){
    var algunaSeleccionada = false;
    this.simulacio.blocs.forEach(bloc => {
      bloc.conjunts.forEach(conjunt => {
        if(conjunt.observacions != null && conjunt.observacions.length>0){
          algunaSeleccionada = true;
        }
      });
    });
    return algunaSeleccionada;
  }

}
